import { Impressionable } from '@fiverr-private/futile/lib/element';

const DOMSelector = '.js-gig-card';
const DOMAttribute = 'data-gig-id';
const dataIdentifier = 'gig_id';

export default class GigImpressionable extends Impressionable {
    constructor(options = {}, enrichData) {
        const basicOptions = {
            DOMSelector,
            DOMAttribute,
            dataIdentifier,
            enrich: (gigData) => this.enrich(gigData)
        };

        const finalOptions = Object.assign(basicOptions, options);

        super(finalOptions);

        const {
            carouselPosition,
            pageCtxId,
            currentUser,
            categoryId,
            subCategoryId,
            carouselTitle,
            sourcepage,
            isPro
        } = enrichData;

        this.carouselPosition = carouselPosition;
        this.pageCtxId = pageCtxId;
        this.currentUser = currentUser;
        this.categoryId = categoryId;
        this.subCategoryId = subCategoryId;
        this.carouselTitle = carouselTitle;
        this.sourcepage = sourcepage;
        this.isPro = isPro;
    }

    enrich(gigData) {
        if (typeof gigData === 'undefined') { return; }

        const page_ctx_id = this.pageCtxId;
        const gig_impression = gigData.impression_data || {};

        gig_impression.category = this.categoryId;
        gig_impression.subcategory = this.subCategoryId;
        gig_impression.position = gigData.$index + 1;
        gig_impression.price = gigData.price_i;
        gig_impression.type = gigData.type;
        gig_impression.source = this.carouselTitle;
        gig_impression.sourcepage = this.sourcepage;

        gig_impression.listings = gigData.listings || {};
        gig_impression.listings.carousel_position = this.carouselPosition;
        gig_impression.listings.url = window.location.href;
        gig_impression.listings.page_ctx_id = page_ctx_id;
        gig_impression.listings.category_id = this.categoryId;
        gig_impression.listings.sub_category_id = this.subCategoryId;
        gig_impression.listings.is_pro = this.isPro;
        gig_impression.listings.carousel_title = this.carouselTitle;

        const logInStatus = typeof this.currentUser === 'undefined' ? 'logged_out' : 'logged_in';
        const type = `homepage.${logInStatus}$viewport`;

        return {
            group: 'gig_impression',
            type,
            gig_impression: [gig_impression],
            aux: { page_ctx_id }
        };
    }
}



// WEBPACK FOOTER //
// ./src/common/HomePage/Gigs/GigImpressionable.js